/**
 * Country → default ISO 4217 currency. Keys match locationData / getCountries().
 */
export const countryToCurrency = {
  USA: 'USD',
  India: 'INR',
  Canada: 'CAD',
  UK: 'GBP',
  Australia: 'AUD',
  'New Zealand': 'NZD',
  Singapore: 'SGD',
  Japan: 'JPY',
  UAE: 'AED',
  Germany: 'EUR',
  Indonesia: 'IDR',
  Kuwait: 'KWD',
  Netherlands: 'EUR',
  Oman: 'OMR',
  'Saudi Arabia': 'SAR',
  Sweden: 'SEK',
};

const ISO_TO_LOCATION_COUNTRY = {
  US: 'USA',
  CA: 'Canada',
  GB: 'UK',
  UK: 'UK',
  AU: 'Australia',
  IN: 'India',
  NZ: 'New Zealand',
  SG: 'Singapore',
  JP: 'Japan',
  AE: 'UAE',
  DE: 'Germany',
  ID: 'Indonesia',
  KW: 'Kuwait',
  NL: 'Netherlands',
  OM: 'Oman',
  SA: 'Saudi Arabia',
  SE: 'Sweden',
};

export const DEFAULT_FEE_CURRENCY = 'USD';

export function normalizeCountryKey(country) {
  if (country == null || country === '') return '';
  const c = String(country).trim();
  if (countryToCurrency[c]) return c;
  const fromIso = ISO_TO_LOCATION_COUNTRY[c] || ISO_TO_LOCATION_COUNTRY[c.toUpperCase()];
  if (fromIso && countryToCurrency[fromIso]) return fromIso;
  const matchKey = Object.keys(countryToCurrency).find(
    (k) => k.toLowerCase() === c.toLowerCase()
  );
  return matchKey || c;
}

export function getCurrencyForCountry(country) {
  const key = normalizeCountryKey(country);
  return countryToCurrency[key] || DEFAULT_FEE_CURRENCY;
}

export function getCurrenciesForCountry(country) {
  const primary = getCurrencyForCountry(country);
  return [...new Set([primary])];
}
